import { useState } from 'react'
import useAxios, { LoadingStatus } from '../useAxios'

// type GainLossReport = {
//   PK: string
//   SK: string
//   createdDatetime: string
//   label: string
//   ownerId: string
//   parameters: string
//   reportName: 'GainLossReport'
//   s3Key: string
//   signedUrl: string
//   status: 'COMPLETE' | 'IN PROGRESS'
//   updatedDatetime: string
// }

type MESSAGE = {
  message: string
  error?: boolean
}

type Asset = {
  amount: string | number
  currency: string
}

type Fiat = {
  amount: string | number
  currency: 'USD'
}

type PostTransactionHandlerProps = {
  id: string
  datetime: string
  type: string
  fees: Asset[]
  received: Asset
  sent: Asset
  price: Fiat
  source: 'string'
}

const usePostTransaction = () => {
  const axios = useAxios()
  const [status, setStatus] = useState<LoadingStatus>('INIT')
  const [message, setMessage] = useState<MESSAGE>({ message: '', error: false })

  const postTransaction = (body: PostTransactionHandlerProps) => {
    setStatus('LOADING')
    axios
      .post('/transaction', body)
      .then((response) => {
        console.log('response =>', response)
      })
      .catch(() => {
        setStatus('ERROR')
        setMessage({ message: 'Failed to add transaction', error: true })
      })
  }

  return [status, message, postTransaction] as const
}

export default usePostTransaction
